import { readonly, reactive } from 'vue'

interface Storage {
	accessToken?: string
}

const storage = reactive<Storage>({
	accessToken: null,
})

const fetchToken = async () => {
	// Here's two ways to fetch token:
	//   1. Fetch from url parameter `token`
	//   2. Fetch from API Server with stored session
	const currentUrl = new URL(window.location.href)
	if (currentUrl.searchParams.has('token')) {
		storage.accessToken = currentUrl.searchParams.get('token')
	}

	if (!storage.accessToken) {
		storage.accessToken = await fetchTokenFromAPI()
	}
}

const fetchTokenFromAPI = async () => {
	try {
		const response = await fetch(`${api_base_url}/facebook/api/access_token`, {
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'include', // include, same-origin, *omit
			headers: {
				'content-type': 'application/json'
			},
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			redirect: 'follow', // manual, *follow, error
			referrer: 'no-referrer', // *client, no-referrer
		})
		const { token } = await response.json()

		return token
	} catch (err) {
		console.log(`Fetch token from API Server error: ${err.message}`)
	}
}

export {
	fetchToken as setup,
}
export const useAccessToken = () => readonly(storage)
